/**
 * Created by LIDA1FH on 03/17/2016.
 */
module.exports = function(bootstrap) {
    bootstrap.directive('clientSiteFooter', ["modal", "navigation", "brand", "services", "session", "$state", "$cookies", "coremetrics", "teamsite","appId","storage",function(modal, navigation, brand, services, session, $state, $cookies, coremetrics, teamsite,appId,storage) {
        return {
            replace: true,
            scope: {},
            template: require('./clientFooter.html'),
            controller: ["$scope", "$q", "coremetrics", "teamsite", "invisibleForm", "brandConfig", function($scope, $q ,coremetrics, teamsite, invisibleForm, brandConfig) {
            }],
            link: function(scope, element) {
                var logoMapping = {
                    9001: "footer/hmbcbs-logo-full.png",
                    9017: "footer/HMWNY_footer.png",
                    9018: "footer/HMNENY_footer.png",
                    9011: "footer/hmbcbsde-logo-full.png",
                    6002: "footer/hbs-logo-full.png",
                    9009: "footer/bcbswv-logo-full.png",
                    6010: "footer/bcbs-minnesota-logo.png",
                    6011: "footer/BCBSND_white.png",
                    6012: "footer/bcbs-WYMlogo.png",
                    9005: "footer/bcbs-florida-logo.png",
                    9007: "footer/bcbs-arizona-logo.png",
                    9006: "footer/bcbs-nebraska-logo.png",
                    9004: "footer/bcbs-minnesota-logo.png",
                    9003: "footer/bc-independence-logo.png",
                    6008: "footer/ibx-logo.png",
                    6009: "footer/ameriHealth.png",
                    9015: "footer/idaho-logo.png",
                    9016: "footer/hmhsla-logo-footer.png"
                  };


                scope.navigation = navigation.data;
                scope.brandData = brand.current;
                scope.adminMode = (session.adminMode == 'undefined' ? false : session.adminMode) ;
            
                if (appId && appId.toLowerCase() === 'eprweb') {
                    scope.isEmployer = true;
                    if (storage.get("switch") === "true") {
                        scope.multiBrand = true;
                        scope.footerbrandLogo = logoMapping[storage.get("currentUbk")];
                        storage.set("footerbrandLogo", scope.footerbrandLogo);
                    }
                }
        
            
            }
           


        }
    }])
};